import(/* webpackMode: "eager" */ "/app/src/app/(site)/quy-trinh/page.tsx");
